// REQ-FE-029e — Supplier status pill rendered per row.
// `Référencé` (green) = supplier with ≥1 received invoice for this société.
// `Nouveau` (salmon)  = INSEE prospect without an invoice yet (no
//     supplier object in the contract today; reserved for when the
//     INSEE prospect feed lands — see AnnuaireScreen INSEE_AVAILABLE).
//
// Mockup: `07-suppliers.png` STATUT column.

export type SupplierStatus = 'known' | 'prospect';

const STATUS_LABEL_FR: Record<SupplierStatus, string> = {
  known: 'Référencé',
  prospect: 'Nouveau',
};

const STATUS_TONE: Record<SupplierStatus, string> = {
  known: 'pill--success',
  prospect: 'pill--warning',
};

interface Props {
  status: SupplierStatus;
}

export function SupplierStatusPill({ status }: Props) {
  return (
    <span className={`pill ${STATUS_TONE[status]}`} data-testid={`supplier-status-${status}`}>
      {STATUS_LABEL_FR[status]}
    </span>
  );
}
